import { QUESTION_KINDS } from '@/shared-question-model';
import { QuestionType } from '@/survey-graphql';

export function toRecordingQuestionKind(type: QuestionType): string {
  return type === QuestionType.Task ? QUESTION_KINDS.Task : type;
}
